"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative w-full overflow-hidden bg-white">
      {}
      <div className="relative min-h-[70vh] md:min-h-[80vh] w-full">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-35" style={{
        backgroundImage: `url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/dubai_professional_audit_team_meeting.png)`,
        transform: "translateZ(0)"
      }} aria-hidden="true" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white/80" />
      </div>

      {}
      <div className="relative z-10 flex items-center justify-center px-6 pt-24 md:pt-32 pb-16 md:pb-20">
        <div ref={ref} className="w-full max-w-6xl space-y-8">
          {}
          <div className={`
              card bg-white rounded-lg px-12 py-8 text-center shadow-soft
              transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]
              hover:shadow-medium hover:-translate-y-1
              ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}
            `} style={{
          transitionDelay: "0ms"
        }}>
            <div className="font-display font-semibold !text-[hsl(22,78%,26%)] !h-[90px] !text-5xl">
              OUR SERVICES
            </div>
          </div>

          {}
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {}
            <div className={`
                card bg-white rounded-lg px-8 py-12 text-center shadow-soft
                transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]
                hover:shadow-medium hover:-translate-y-1
                ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}
              `} style={{
            transitionDelay: "150ms"
          }}>
              <div className="mb-4 text-6xl font-bold !text-[hsl(22,78%,26%)]">
                + 20
              </div>
              <div className="font-display text-2xl font-semibold !text-[hsl(22,78%,26%)]">
                Years Of Experience
              </div>
            </div>

            {}
            <div className={`
                card bg-white rounded-lg px-8 py-12 text-center shadow-soft
                transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]
                hover:shadow-medium hover:-translate-y-1
                ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}
              `} style={{
            transitionDelay: "450ms"
          }}>
              <div className="mb-4 text-6xl font-bold !text-[hsl(22,78%,26%)]">
                + 10000
              </div>
              <div className="font-display text-2xl font-semibold !text-[hsl(22,78%,26%)]">
                Audits Completed
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}